module.exports = __webpack_public_path__ + "img/logo2.323cccb5.png";